import { Text, Box, styled } from '@/theme/index';

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  marginBottom: '20px',
  borderRadius: '10px',
  border: `1px solid #E2E2E2`,
  borderLeft: `12px solid ${theme.palette.primary.main}`,
  padding: '15px 25px 17px',
  color: theme.palette.text.primary,
}));

export const ObituaryRelativesEmptyBox = styled(Text)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  width: '100%',
  borderRadius: '5px',
  padding: '10px',
  cursor: 'default',
  '&:hover': {
    backgroundColor: theme.palette.background.default,
  },
}));

export const StyledText = styled(Text)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'light',
  marginBottom: '5px',
  color: theme.palette.common.black,
  display: 'flex',
  alignItems: 'center',
  opacity: 0.6,
}));

export const StyledAccomplishment = styled(Text)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.main,
  padding: '10px 15px',
  borderRadius: '20px',
  margin: '0 10px 15px 0',
}));
